import { gql } from '@apollo/client';

export const QUERY_CONVERSATIONS = gql`
  query GetConversations($input: GetConversationsInput!) {
    getConversations(input: $input) {
      total
      conversations {
        title
        messages {
          content
          conversation_id
        }
      }
    }
  }
`;

export const QUERY_CONVERSATIONS_HISTORY = gql`
  query GetConversationsHistory($conversationId: String!) {
    getConversationHistory(conversation_id: $conversationId) {
      content
      id
      role
      conversation_id
    }
  }
`;

export const QUERY_CONVERSATIONS_HISTORY_BY_ID = gql`
  query GetConversations($input: GetConversationsInput!) {
    getConversations(input: $input) {
      total
      conversations {
        messages {
          content
          role
          conversation_id
        }
      }
    }
  }
`;
